module.exports = __webpack_public_path__ + "img/arrow-spoiler.ddc319ba.svg";